import React from 'react';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import HorizontalFormInput from '../../../../../../../../components/FormHelpers/horizontalFormInput';
import Suppliers from '../../../../../../components/Suppliers';

const needsToBePicked = (value) => 
  value || typeof value === 'boolean' ? true : 'Fältet måste fyllas i';

const RadioField = ({ name, value, label, control }) => (
  <Controller
    name={name}
    control={control}
    rules={{ validate: needsToBePicked }}
    render={({ field, fieldState: { error } }) => (
      <div className="form-check form-check--inline">
        <label className="form-check__label">
          <input
            {...field}
            type="radio"
            value={value}
            checked={field.value === value}
            onChange={() => field.onChange(value)}
            className="form-check__input"
          />
          {label}
        </label>
        {error && (
          <span className="help-text help-text--has-error">{error.message}</span>
        )}
      </div>
    )}
  />
);

const GdprInput = () => {
  const { control } = useFormContext();
  const hasPersonalDetails = useWatch({
    control,
    name: 'gdpr.hasPersonalDetails'
  });

  return (
    <>
      <RadioField
        name="gdpr.hasPersonalDetails"
        control={control}
        value={true}
        label="Register innehållande personuppgifter"
      />
      <RadioField
        name="gdpr.hasPersonalDetails"
        control={control}
        value={false}
        label="Register utan personuppgifter"
      />

      {hasPersonalDetails && (
        <div className="card">
          <div className="card-header">
            <div className="card-header__title">Information om filinnehåll</div>
          </div>

          <div className="card__body form">
            <HorizontalFormInput
              name="gdpr.type"
              control={control}
              rules={undefined}
              className="form-control"
              label="Typ av uppgift"
              placeholder="Ex: namn och e-postadresser/adressuppgifter till privatpersoner"
            />
            <HorizontalFormInput
              name="gdpr.purpose"
              control={control}
              rules={undefined}
              className="form-control"
              label="Syfte"
              placeholder="Ex: kundens DR aktivitet"
            />
            <HorizontalFormInput
              name="gdpr.noOfEntities"
              control={control}
              rules={undefined}
              className="form-control"
              label="Antal poster"
              placeholder="Ex: ca 4500st"
            />
            <HorizontalFormInput
              name="gdpr.description"
              control={control}
              rules={undefined}
              renderAs="textarea"
              className="form-control textarea--no-resize"
              rows={4}
              label="Uppdragsbeskrivning"
              placeholder="Urvalsparametrar, dvs vad har kunden beställt"
            />
          </div>
        </div>
      )}

      {hasPersonalDetails && (
        <>
          <h2>Adresskällor</h2>
          <Suppliers />
        </>
      )}
    </>
  );
};

export default GdprInput;
